export default "__VITE_ASSET__VcJBgiLX__"